export default __webpack_public_path__ + "static/media/tv2Bg.0d4b9616.jpg";